import moment from 'moment-jalaali';
import './Footer.css';

function Footer() {
    const currentJalaaliYear = moment().jYear();
    const nextJalaaliYear = currentJalaaliYear + 1;
    const yearRange = `${currentJalaaliYear} - ${nextJalaaliYear}`;

    return (
        <footer className="footer">
            <p className="fs-11 text-muted fw-medium text-uppercase mb-0 copyright">
                <span>تمامی حقوق محفوظ است © {yearRange}</span>
            </p>
        </footer>
    );
}

export default Footer;